import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';

export const nestedGroup = style(
  {
    border: `${themeVars.border['width-0125']} solid ${themeVars.color['border-minimal']}`,
    background: themeVars.color['surface-base'],
    borderRadius: themeVars.radius['4'],
    padding: themeVars.space['125'],
  },
  'condition-group-nested',
);
